import { AnimatePresence, motion } from "framer-motion";
import type { ReactNode, CSSProperties } from "react";

export interface CollapseTransitionProps {
  show: boolean;
  children: ReactNode;
  duration?: number;
  className?: string;
  style?: CSSProperties;
  id?: string;
  "data-testid"?: string;
}

const CollapseTransition = ({
  show,
  children,
  duration = 0.25,
  className,
  style,
  id,
  "data-testid": dataTestId
}: CollapseTransitionProps) => {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          id={id}
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration, ease: "easeInOut" }}
          className={className}
          style={{ overflow: "hidden", ...style }}
          data-testid={dataTestId ?? "collapse-transition"}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CollapseTransition;
